module.exports = __webpack_public_path__ + "img/103ne.585abb44.svg";